import { InjectionToken, Provider } from '@angular/core';
import type { EnvironmentModel } from '@privanot/shared-models';

export const ENVIRONMENT = new InjectionToken<EnvironmentModel>('EnvironmentModel');

export function provideEnvironment(env: EnvironmentModel): Provider {
    return { provide: ENVIRONMENT, useValue: env };
}
